<section id="wrapper" class="error-page">
  <div class="error-box">
      <div class="error-body text-center">
          <h1>404</h1>
          <h3 class="text-uppercase">¡Página no encontrada!</h3>
          <p class="text-muted m-t-30 m-b-30">Lo siento, la página no ha sido</p>
          <a href="index.html" class="btn btn-info btn-rounded waves-effect waves-light m-b-40">Back to home</a> </div>
      <footer class="footer text-center">© 2017 Admin Pro.</footer>
  </div>
</section>


